import React, { Component } from "react";
import { Paper } from "@material-ui/core";
import { NEW_TRANSACTION_URL } from ".";
import Image from "../../Image";
import { connect } from "react-redux";
class TransactionTypeCards extends Component {
  constructor() {
    super();
    console.log(this.props);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  getUrlByName = (name) => {
    let url = `/`;
    switch (name) {
      case "SIP (Existing Folio)":
        url = `${NEW_TRANSACTION_URL}/sip/digital/transact`;
        break;
      case "SIP (New Folio)":
        url = `/cart-sip`;
        break;
      case "STP":
        url = NEW_TRANSACTION_URL + "/stp/digital/transact";
        break;
      case "Switch":
        url = NEW_TRANSACTION_URL + "/switch/digital/transact";
        break;
      case "Redemption":
        url = NEW_TRANSACTION_URL + "/redemption/digital/transact";
        break;
      case "SWP":
        url = NEW_TRANSACTION_URL + "/swp/digital/transact";
        break;
      case "New Purchase + SIP (New Folio)":
        url = "/new-investor-transaction/investor-details";
        break;
      case "Additional Purchase":
        url = NEW_TRANSACTION_URL + "/additional-purchase/digital/transact";
        break;
      case "Pause/Cancellation":
        url = NEW_TRANSACTION_URL + "/sip-cancellation/digital/transact";
        break;
      case "NCT":
        url = NEW_TRANSACTION_URL + "/nct-types";
        break;
      case "eNACH(KOTM)":
        url = NEW_TRANSACTION_URL + "/eNACH/digital/transact";
        break;
      case "NPS":
        url = "/nps/AddSubs/new-reg";
        break;
      case "New Purchase":
        if (this.props.isCartUser) {
          return "/cart-new-purchase";
        }
        if (this.props.history?.location?.state?.new) {
          url = "/new-investor-transaction/investor-details";
        } else {
          url = NEW_TRANSACTION_URL + "/nfo-new-purchase/digital/transact";
        }
        break;
      default:
        url = "/";
    }
    return url;
  };
  render() {
    const panShow = [
      "New Purchase + SIP (New Folio)",
      "SIP (Existing Folio)",
      "SIP (New Folio)",
    ].some((ele) => ele === this.props.name);

    const isPhygital = ![
      "NCT",
      "Pause/Cancellation",
      "eNACH(KOTM)",
      "NPS",
    ].includes(this.props.name);

    return (
      <div className="transction-typemain">
        <Paper
          className="transaction-type-cards-paper"
          style={{
            boxShadow: "-1px 1px 3px 1px lavender",
            padding: "15px 0px 0px 0px",
            borderRadius: 8,
          }}
          onClick={this.props.onClick}
        >
          <div className="otp">
            <Image
              src={`${this.props.image}`}
              style={{ height: 80 }}
              alt={this.props.name}
            />
          </div>
          <div className="transaction-type-cards-name">{this.props.name}</div>
          {isPhygital ? (
            <div
              style={{
                display: "flex",
                boxShadow: "1px -2px 2px -1px lavender",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexGrow: 1,
                  fontSize: 13,
                  color: "#007AC8",
                  fontFamily: "OpenSans-SemiBold",
                  flexBasis: 0,
                  padding: "15px 0px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  this.props.history.push({
                    pathname: this.getUrlByName(this.props.name),
                    state: {
                      pan: [
                        "New Purchase + SIP (New Folio)",
                        "SIP (New Folio)",
                      ].includes(this.props.name)
                        ? this.props.user_pan
                        : !!this.props.pan && panShow
                        ? this.props.pan
                        : "",
                      isSip: this.props.name === "SIP (New Folio)",
                    },
                  })
                }
              >
                Digital Mode
              </div>
              <div
                style={{
                  display: "flex",
                  padding: "15px 0px",
                  justifyContent: "center",
                  color: "#007AC8",
                  borderLeft: "2px solid #f8f8f8",
                  fontSize: 13,
                  fontFamily: "OpenSans-SemiBold",
                  flexGrow: 1,
                  flexBasis: 0,
                  cursor: "pointer",
                }}
                onClick={() =>
                  this.props.history.push({
                    pathname: this.props.navigationProps.physical,
                    state: {
                      type: this.props.navigationProps.type,
                      flag: this.props.navigationProps.flag,
                      pan: this.props.user_pan,
                    },
                  })
                }
              >
                Phygital Mode
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                boxShadow: "1px -2px 2px -1px lavender",
              }}
            >
              <div
                style={{
                  display: "flex",
                  padding: "15px 0px",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#007AC8",
                  borderLeft: "2px solid #f8f8f8",
                  fontSize: 13,
                  fontFamily: "OpenSans-SemiBold",
                  flexGrow: 1,
                  flexBasis: 0,
                }}
                onClick={() =>
                  this.props.history.push({
                    pathname: this.getUrlByName(this.props.name),
                    state: {
                      pan: ["eNACH(KOTM)", "NPS", "SIP"].includes(
                        this.props.name
                      )
                        ? this.props.user_pan
                        : "",
                    },
                  })
                }
              >
                Proceed
              </div>
            </div>
          )}
        </Paper>
      </div>
    );
  }
}
export default connect(({ authReducer }) => {
  const { nomineeFlag, user_pan, isCartUser } = authReducer;
  return { nomineeFlag, user_pan, isCartUser };
})(TransactionTypeCards);
